export default "/num2.png";